import {LOCALE_ID, APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";

import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';
import {
	GROUP_SIMILAR_NOTIFICATIONS,
	OB_ACTIVATE_SERVICE_NAVIGATION,
	OB_BANNER,
	ObButtonModule,
	ObExternalLinkModule,
	ObHttpApiInterceptor,
	ObHttpApiInterceptorConfig,
	ObIconModule,
	ObMasterLayoutConfig,
	ObMasterLayoutModule,
	TRANSLATION_FILES,
	multiTranslateLoader
} from '@oblique/oblique';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {registerLocaleData} from '@angular/common';
import localeDECH from '@angular/common/locales/de-CH';
import localeFRCH from '@angular/common/locales/fr-CH';
import localeITCH from '@angular/common/locales/it-CH';
import localeENGB from '@angular/common/locales/en-GB';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {environment} from '../environments/environment';
import {HomeComponent} from './home/home.component';
import {MatLegacyButtonModule} from '@angular/material/legacy-button';
import {MatLegacyCardModule} from '@angular/material/legacy-card';
import {MatIconModule} from '@angular/material/icon';
import {RouterModule} from '@angular/router';
import {MatTableModule} from '@angular/material/table';
import {VerificationStatusComponent} from './home/status/status.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {LoginComponent} from './home/login/login.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import {MatStepperModule} from "@angular/material/stepper";

import { Router } from "@angular/router";
import * as Sentry from "@sentry/angular";

export const options: Partial<null | IConfig> | (() => Partial<IConfig>) = null;

registerLocaleData(localeDECH);
registerLocaleData(localeFRCH);
registerLocaleData(localeITCH);
registerLocaleData(localeENGB);

@NgModule({
	declarations: [AppComponent, HomeComponent, LoginComponent, VerificationStatusComponent],
	imports: [
		RouterModule.forRoot([
			{
				path: '',
				component: HomeComponent
			}
		]),
		BrowserAnimationsModule,
		BrowserModule,
		HttpClientModule,
		TranslateModule.forRoot(multiTranslateLoader()),
		FormsModule,
		ReactiveFormsModule,
		ObMasterLayoutModule,
		ObButtonModule, // add other Oblique modules as needed
		ObIconModule.forRoot(),
		ObExternalLinkModule,
		MatLegacyButtonModule,
		MatLegacyCardModule,
		MatTableModule,
		MatIconModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		NgxMaskModule.forRoot(),
		MatStepperModule
	],
	providers: [
		{
			provide: ErrorHandler,
			useValue: Sentry.createErrorHandler({
			  showDialog: false,
			}),
		}, 
		{provide: Sentry.TraceService, deps: [Router]},
		{provide: LOCALE_ID, useValue: 'de-CH'},
		{provide: TRANSLATION_FILES, useValue: [{prefix: './assets/i18n/', suffix: '.json'}]},
		{provide: HTTP_INTERCEPTORS, useClass: ObHttpApiInterceptor, multi: true},
		{provide: OB_BANNER, useValue: environment.banner},
		{provide: OB_ACTIVATE_SERVICE_NAVIGATION, useValue: true},
		{provide: GROUP_SIMILAR_NOTIFICATIONS, useValue: true}
	],
	bootstrap: [AppComponent]
})
export class AppModule {
	constructor(private readonly obMasterLayoutConfig: ObMasterLayoutConfig, private readonly obHttpApiInterceptorConfig: ObHttpApiInterceptorConfig) {
		obMasterLayoutConfig.locale.locales = ['de-CH', 'fr-CH', 'it-CH', 'en-US'];
		obMasterLayoutConfig.header.serviceNavigation.displayProfile = true;
		obMasterLayoutConfig.footer.isCustom = true;

		// needed to avoid spinner activating every few background requests
		obHttpApiInterceptorConfig.api.spinner = false;
	}
}
